module.exports = __webpack_public_path__ + "Flag-434.ed9d66369dfbce3090fe50cdf4f70ca6.svg";